var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"complement-information"},[_c('van-field',{attrs:{"label":"授权品牌：","value":"水光生","readonly":"","input-align":"right"}}),_c('personal-info',{ref:"personalInfo",on:{"loaded":_vm.restore}}),_c('div',{staticClass:"submit",on:{"click":_vm.onSubmit}},[_vm._v("提交")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }